import React, { FC } from 'react';
import styled from 'styled-components';

export enum StatusState {
  COMPLETED = '7',
  SEATED = '6',
  NO_SHOW = '8',
  OVERDUE = '5',
  CANCELLED = '0',
  NEW = '1',
  CONFIRMED = '2',
}

type StatusComponentProps = {
  status?: StatusState;
  label?: string;
};

const StatusComponent: FC<StatusComponentProps> = ({ status, label }) => {
  const statusStyle = statusStyles(status);
  if (!label) return <></>;
  return <StyledStatus style={statusStyle}>{label}</StyledStatus>;
};

export default StatusComponent;

const statusStyles = (status?: StatusState) => {
  switch (status) {
    case StatusState.COMPLETED:
    case StatusState.SEATED:
      return {
        background: '#E5FCEF',
        color: '#539A59',
      };
    case StatusState.OVERDUE:
      return {
        background: '#F2E4DC',
        color: '#BC1823',
      };
    case StatusState.NEW:
      return {
        background: '#FFF5D9',
        color: '#996B0F',
      };
    case StatusState.CONFIRMED:
      return {
        background: '#CAF4FF',
        color: '#03AED2',
      };
    case StatusState.CANCELLED:
    case StatusState.NO_SHOW:
    default:
      return {
        background: '#E8E8E8',
        color: '#7D7D7D',
      };
  }
};

const StyledStatus = styled.div`
  width: 'auto';
  height: 25px;
  min-width: 100px;
  padding: 1.5px 10px;
  border-radius: 50px;
  font-size: 12px;
  line-height: 22px;
  letter-spacing: 2%;
  line-height: 22px;
  margin: auto;
  white-space: nowrap;
  display: inline-block;
`;
